import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { GROUP_ACTIVE_STATUS, GROUP_ACTIVE_STATUS_LABEL } from 'constants/groups';

import { useGroupsContext } from '../GroupsContext';

const GroupsFiltersActive = () => {
  const { filters, setFilters } = useGroupsContext();

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, status: values });
  };

  const options = [
    {
      label: GROUP_ACTIVE_STATUS_LABEL[GROUP_ACTIVE_STATUS.INACTIVE],
      value: GROUP_ACTIVE_STATUS.INACTIVE,
    },
    {
      label: GROUP_ACTIVE_STATUS_LABEL[GROUP_ACTIVE_STATUS.ACTIVE],
      value: GROUP_ACTIVE_STATUS.ACTIVE,
    },
  ];

  return (
    <SelectAdvancedFilter
      className={classNames({ active: Boolean(filters.status?.length) })}
      placeholder={'Status'}
      options={options}
      defaultValue={filters?.status ?? []}
      onSelect={handleSelect}
    />
  );
};

export default GroupsFiltersActive;
